import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { themeColor, themeSpace } from '@utils/styledTheme.util';
import styled from 'styled-components';

export const StyledCardWrapper = styled(Flex)`
  border-radius: ${themeSpace(5)};
  padding: ${themeSpace(7)};
  flex-direction: column;
  row-gap: ${themeSpace(3)};
  justify-content: center;
  background-color: ${themeColor('white')};
  width: 100%;
  height: 100%;
`;

export const StyledTextPairing = styled(TextPairing)`
  .text-pairing-title {
    white-space: pre-wrap;
  }
`;
